import { formatDate, mString } from 'lib/helpers/utility';

export const DEFAULT_FILTERS = {
  date: {
    values: null,
    type: 'date-range',
    title: 'Date of Transaction',
    preview: (values) => `${formatDate(values.startDate)} - ${formatDate(values.endDate)}`
  },
  status: {
    type: 'checkbox',
    options: ['started', 'cancelled', 'completed', 'initiated', 'voided', 'failed'],
    values: null,
    title: 'Status',
    preview: (values) => values.map((v) => v.label).join(', ')
  },
  type: {
    type: 'search',
    multiple: true,
    options: [
      {
        label: 'Card Present',
        value: 'CARD_PRESENT'
      },
      {
        label: 'In Progress',
        value: 'IN_PROGRESS'
      },
      {
        label: 'Amex',
        value: 'amex'
      },
      {
        label: 'Cash',
        value: 'cash'
      },
      {
        label: 'Online',
        value: 'ONLINE'
      },
      {
        label: 'Charge',
        value: 'charge'
      },
      {
        label: 'Check',
        value: 'check'
      }
    ],
    values: [],
    title: 'Type',
    preview: (values) => values.map((v) => v.label).join(', ')
  },
  amount: {
    min: 0,
    max: 1000,
    values: 0,
    type: 'range',
    title: 'Amount',
    preview: (values) => mString(values)
  },
  cashier: {
    type: 'search',
    multiple: true,
    options: [],
    values: [],
    title: 'Cashier',
    preview: (values) => values.map((v) => v.label).join(', ')
  }
};
